
export class FileLogger {

  static async init() {
    
  }

}